import type { Address } from "viem";
import { getL2ClientAsync, waitForBlockWithProgress } from "../aztec-utils";
import { getL1Portal, getL2Portal } from "../lib/singletons";
import { setBlockWaitingProgress } from "../state/blockWaitingProgress";

export async function registerL1Token(tokenAddress: Address) {
  const portal = await getL1Portal();

  // Register the token with the L1 Portal
  const result = await portal.register(tokenAddress);
  console.log(`Registered token with the L1 Portal in tx ${result.txHash}`);

  const { txHash, messageHash: hash, messageIndex: index, l2BlockNumber } = result;

  return {
    txHash,
    tokenAddr: tokenAddress,
    hash,
    l2BlockNumber,
    index,
  };
}

export async function registerL2Token(
  tokenAddr: Address,
  tokenName: string,
  tokenSymbol: string,
  tokenDecimals: number,
  l2BlockNumber: number,
  index: bigint,
) {
  // We need to wait for the L2 block to be mined so that the L1ToL2Message is available on the L2 chain.
  setBlockWaitingProgress({
    currentBlock: await (await getL2ClientAsync()).getNode().getBlockNumber(),
    targetBlock: Number(l2BlockNumber),
    isWaiting: true,
  });

  await waitForBlockWithProgress(
    Number(l2BlockNumber),
    (currentBlock, targetBlock) => {
      setBlockWaitingProgress({ currentBlock, targetBlock, isWaiting: true });
    },
    2000,
    60,
  );

  // Clear the progress once we're done waiting
  setBlockWaitingProgress(null);

  const aztecPortal = await getL2Portal();

  const l2Client = await getL2ClientAsync();


  const { instance, txHash }= await aztecPortal.deployAndRegisterL2Token(tokenAddr, tokenName, tokenSymbol, tokenDecimals, index, {
    from: await l2Client.getAddress()
  });
  const l2TokenAddr = instance.address;

  console.log(`Registered token ${tokenSymbol} with the Aztec Portal as L2 address ${l2TokenAddr}`);

  return txHash.toString();
}
